import { YMMetricHelper, createMetric } from '@beef/metric';

import { ymPushEvent } from 'utils/analytics/ym';

import { ANALYTICS_ACTION, ANALYTICS_ITEM_TYPE } from './constants';

const MNP_PARAM_KEY = 'LP_MNP_2025';

export class MnpMetric extends YMMetricHelper {
  protected setMnp = (params: Record<string, any>) => {
    return {
      [MNP_PARAM_KEY]: {
        page_title: document.title,
        page_url: window.location.href,
        page_path: window.location.pathname,
        ...params,
      },
    };
  };

  /** Клик для получения всех балансов */
  handleMnpMetrics(data) {
    this.sendParamsEvent(
      this.setMnp({
        action: ANALYTICS_ACTION.click,
        item_type: ANALYTICS_ITEM_TYPE.ICON,
        icon_type: 'plus',
        ...data,
      }),
    );
  }
}

export const mnpMetric = new MnpMetric({
  counterId: 26001309,
  isEcommerce: false,
  debug: false,
});

export const { Metric, decorateHandler, withMetricContainer, withMetricListeners } = createMetric(
  {
    mnpMetric,
  },
  'debug',
);

export const ymPushMnpMetric = (data) => {
  if (window) {
    ymPushEvent({
      [MNP_PARAM_KEY]: {
        page_title: document.title,
        page_url: window.location.href,
        page_path: window.location.pathname,
        ...data,
      },
    });
  }
};
